/*
=========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/    o o o  

=========================================================
*/

export const APP_STATE = "TUTORBACKEND";
// export const API = "http://localhost/rapidbackend/public";
export const API = "";
export const DEBUG = false;
export const DEBUG_ID = "";
export const DEBUG_TOKEN = "";
export const DEBUG_NAME = "";
export const DEBUG_PIC = "";
export const DEBUG_STATUS = "";
export const DEBUG_EMAIL = "";

export const APP_NAME = "";
export const API_URL = "";

/* LINE LIFF */
export const LIFF_ID = "";
